import Message from './Message';

export default Message;

export type { MessageType } from './Message';
